import { colors } from '@src/core/theme';
import styled from 'styled-components';
import useTranslate from '@src/i18n/useTranslate';
import { BodyRegular, Heading6 } from '@src/fonts/typography/Typography';
import React from 'react';
import { device } from '@src/common/breakpoints';
import CardExpired from '@src/assets/images/CardExpired.svg';

type Props = {
  horizontalStyle?: boolean;
  title?: string;
  helperText?: string;
};

export const ProviderFinancialError = (props: Props) => {
  const { i18n } = useTranslate();

  const {
    horizontalStyle = true,
    title = i18n('checkout_payment_gateway_mismatch_error_title'),
    helperText = i18n('checkout_payment_gateway_mismatch_error_description'),
  } = props;

  return (
    <Content horizontalStyle={horizontalStyle}>
      <Image>
        <CardExpired />
      </Image>

      <Texts>
        <Title>{title}</Title>

        <Description>{helperText}</Description>
      </Texts>
    </Content>
  );
};

const Image = styled.div``;

const Texts = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  gap: 16px;
`;

interface ContentProps {
  horizontalStyle: boolean;
}

const Content = styled.div<ContentProps>`
  display: flex;
  flex-flow: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  margin: auto;

  ${({ horizontalStyle }) =>
    horizontalStyle &&
    `
    ${device.smallTablet} {
      flex-direction: row-reverse;
      text-align: left;
      padding: 40px;
      gap: 50px;
    }
  `}
`;

const Title = styled.h6`
  ${Heading6};

  color: ${colors.primary[500]};
`;

const Description = styled.p`
  ${BodyRegular};
  color: ${colors.grey[700]};
`;
